import { lazy } from "react";

export { SETTINGS_PATH } from "./settings-path";
export const Settings = lazy(() => import("./settings"));
